import type { PdfTemplateCategory } from "./templates";

// Local translations
export const T = {
  en_GB: {
    createFromTemplate: "Create PDF Template from Template",
    templateDialogDescription: "Choose a pre-configured PDF template to get started quickly.",
    configureTemplate: "Configure",
    configureTemplateDescription: "Configure your PDF template settings before creating.",
    searchTemplates: "Search templates...",
    noTemplatesFound: "No templates found",
    sections: "Sections",
    pages: "Pages",
    components: "Components",
    selectTemplatePrompt: "Select a template from the list to see details",
    cancel: "Cancel",
    next: "Next",
    back: "Back",
    templateName: "Template Name",
    templateNamePlaceholder: "e.g., Client Investment Report",
    description: "Description",
    descriptionPlaceholder: "A comprehensive report for client portfolios",
    flow: "Flow",
    selectFlow: "Select a flow",
    pleaseSelectFlow: "Please select a flow",
    noFlowsForLanguage: "No flows available for this language",
    // QL-212 — the template places the risk block where this flow's model prints nothing
    riskScopeMismatch:
      "This flow's risk model would print nothing where this template places the risk assessment. Pick another flow, or move the component after creating the template.",
    create: "Create",
    failedToCreate: "Failed to create PDF template",
    templateNameRequired: "Template name is required",
    language: "Language",
    selectLanguage: "Select language",
    scope: "Scope",
    global: "Global",
    perGoal: "Per Goal",
    perPortfolio: "Per Portfolio",
    missingPrefix: "Missing:",
    missingTimeseries: "requires timeseries",
    missingAssetAllocation: "requires asset allocation",
    categories: {
      basic: { name: "Basic", description: "Simple templates for getting started" },
      advisory: { name: "Advisory", description: "Templates for investment advice documentation" },
      execution: { name: "Execution", description: "Templates for order execution documentation" },
      reporting: { name: "Reporting", description: "Templates for periodic reports and summaries" },
    } satisfies Record<PdfTemplateCategory, { name: string; description: string }>,
  },
  nb_NO: {
    createFromTemplate: "Opprett PDF-mal fra mal",
    templateDialogDescription: "Velg en forhåndskonfigurert PDF-mal for å komme raskt i gang.",
    configureTemplate: "Konfigurer",
    configureTemplateDescription: "Konfigurer PDF-malinnstillingene før du oppretter.",
    searchTemplates: "Søk i maler...",
    noTemplatesFound: "Ingen maler funnet",
    sections: "Seksjoner",
    pages: "Sider",
    components: "Komponenter",
    selectTemplatePrompt: "Velg en mal fra listen for å se detaljer",
    cancel: "Avbryt",
    next: "Neste",
    back: "Tilbake",
    templateName: "Malnavn",
    templateNamePlaceholder: "f.eks. Kundeinvesteringsrapport",
    description: "Beskrivelse",
    descriptionPlaceholder: "En omfattende rapport for kundeporteføljer",
    flow: "Flyt",
    selectFlow: "Velg en flyt",
    pleaseSelectFlow: "Vennligst velg en flyt",
    noFlowsForLanguage: "Ingen flyter tilgjengelig for dette språket",
    // QL-212 — malen plasserer risikoblokken der denne flytens modell ikke skriver ut noe
    riskScopeMismatch:
      "Denne flytens risikomodell ville ikke skrevet ut noe der denne malen plasserer risikovurderingen. Velg en annen flyt, eller flytt komponenten etter at malen er opprettet.",
    create: "Opprett",
    failedToCreate: "Kunne ikke opprette PDF-mal",
    templateNameRequired: "Malnavn er påkrevd",
    language: "Språk",
    selectLanguage: "Velg språk",
    scope: "Omfang",
    global: "Global",
    perGoal: "Per mål",
    perPortfolio: "Per portefølje",
    missingPrefix: "Mangler:",
    missingTimeseries: "krever tidsserie",
    missingAssetAllocation: "krever aktivaallokering",
    categories: {
      basic: { name: "Grunnleggende", description: "Enkle maler for å komme i gang" },
      advisory: {
        name: "Rådgivning",
        description: "Maler for dokumentasjon av investeringsrådgivning",
      },
      execution: { name: "Utførelse", description: "Maler for dokumentasjon av ordreutførelse" },
      reporting: {
        name: "Rapportering",
        description: "Maler for periodiske rapporter og oppsummeringer",
      },
    } satisfies Record<PdfTemplateCategory, { name: string; description: string }>,
  },
} as const;
